// src/mocks/handlers/index.ts
import { authHandlers } from './auth';
import { customerHandlers } from './customer';
import { userHandlers } from './user';
import { sourcesHandlers } from './sources';
import { fundingHandlers } from './funding';
import { filtersHandlers } from './filters';
import { dashboardHandlers } from './dashboard';
import { accountHandlers } from './account';

export const handlers = [
  ...authHandlers,
  ...userHandlers,
  ...customerHandlers,
  ...dashboardHandlers,
  ...sourcesHandlers,
  ...fundingHandlers,
  ...filtersHandlers,
  ...accountHandlers,
];
